import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { UserHttp } from '@/services';
import { SubsidyItem } from '@/services/user.service';

export interface CreditSlice {
  credit: number;
  subsidyCredit: number;
  loadingCredit: boolean;
  creditError: Error | null;
  subsidies: SubsidyItem[];
  apiVersion: string | null;
  apiReleaseDate: string | null;
  loadingApiVersion: boolean;
  apiVersionError: unknown;
  fetchCredit(): Promise<void>;
  setCredit(data: CreditSlice): any;
  fetchApiVersion: () => Promise<void>;
  setApiVersion: (version: string) => void;
}

export interface AppSlice extends CreditSlice {
}

const initialState = {
  credit: null,
  subsidyCredit: null,
  loadingCredit: false,
  creditError: null,
  subsidies: [],
  apiVersion: null,
  apiReleaseDate: null,
  loadingApiVersion: false,
  apiVersionError: null,
} as AppSlice;

const mutations = (
  setState: (...params: Partial<AppSlice>[]) => any,
  _getState: () => AppSlice
) => {
  return {
    fetchCredit: async () => {
      setState({ loadingCredit: true, creditError: null });
      try {
        const profile = (await UserHttp.fetchNurtureProfile()).payload;
        setState({
          loadingCredit: false,
          credit: profile.credit,
          subsidyCredit: profile.subsidyCredit,
          subsidies: profile?.subsidies ?? []
        });
      }
      catch (e) {
        setState({ creditError: e, credit: null, subsidyCredit: null });
      }
    },
    setCredit: (data: CreditSlice) => setState(data),
    fetchApiVersion: async () => {
      setState({ loadingApiVersion: true, apiVersionError: null });
      try {
        const res = await UserHttp.fetchReleases();
        const version = res?.payload?.version ?? res?.payload?.version ?? null;
        const releaseDate = res?.payload?.releaseTime ?? res?.payload?.releaseTime ?? null;

        setState({ apiVersion: version, loadingApiVersion: false ,apiReleaseDate:releaseDate});
      } catch (error) {
        setState({ apiVersion: null, loadingApiVersion: false, apiReleaseDate: '100908183211' });
      }
    },
    setApiVersion: (version: string) => setState({ apiVersion: version }),
  };
};

const appStore = create(combine(initialState, mutations as any));

export default appStore;
